import React from 'react';
import type { OnboardingDotsProps } from './types';

/** Progress indicator for the onboarding carousel — no shared carousel primitive exists yet in `ui/`. */
export const OnboardingDots: React.FC<OnboardingDotsProps> = ({ total, current }) => (
    <div className="flex items-center gap-s" data-testid="onboarding-dots" role="img" aria-label={`${current}/${total}`}>
        {Array.from({ length: total }, (_, i) => i + 1).map((step) => (
            <span
                key={step}
                data-testid={`onboarding-dot-${step}`}
                className={step === current
                    ? 'h-1.5 w-4 rounded-full bg-accent-400'
                    : 'h-1.5 w-1.5 rounded-full bg-primary-300'}
            />
        ))}
    </div>
);
